import { PARTNER_FEES_FORM_FIELDS, PARTNER_FEES_FORM_FIELDS_NAMES } from './partner-fees-form';
import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { ISelectorData } from '../../components/application/NewApplication';

export const PARTNER_FEES_INPUTS = ({ feeTypes }: { feeTypes: ISelectorData[] }): IFormInputProps[] => [
	{
		key: PARTNER_FEES_FORM_FIELDS.GROUP,
		fieldName: PARTNER_FEES_FORM_FIELDS.GROUP,
		placeholder: PARTNER_FEES_FORM_FIELDS_NAMES.GROUP,
		label: PARTNER_FEES_FORM_FIELDS_NAMES.GROUP,
		inputType: InputType.Text,
		// required: true,
		additionalClasses: 'col-sm-6 col-md-6',
		autoComplete: 'off'
	},
	{
		key: PARTNER_FEES_FORM_FIELDS.NAME,
		fieldName: PARTNER_FEES_FORM_FIELDS.NAME,
		placeholder: PARTNER_FEES_FORM_FIELDS_NAMES.NAME,
		label: PARTNER_FEES_FORM_FIELDS_NAMES.NAME,
		inputType: InputType.Text,
		required: true,
		additionalClasses: 'col-sm-6 col-md-6 ',
		autoComplete: 'off'
	},
	{
		key: PARTNER_FEES_FORM_FIELDS.AMOUNT,
		fieldName: PARTNER_FEES_FORM_FIELDS.AMOUNT,
		placeholder: PARTNER_FEES_FORM_FIELDS_NAMES.AMOUNT,
		label: PARTNER_FEES_FORM_FIELDS_NAMES.AMOUNT,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-sm-6 col-md-6',
		autoComplete: 'off'
	},
	{
		key: PARTNER_FEES_FORM_FIELDS.TYPE,
		fieldName: PARTNER_FEES_FORM_FIELDS.TYPE,
		placeholder: PARTNER_FEES_FORM_FIELDS_NAMES.TYPE,
		label: PARTNER_FEES_FORM_FIELDS_NAMES.TYPE,
		inputType: InputType.Select,
		data: feeTypes,
		searchable: false,
		cleanable: false,
		required: true,
		additionalClasses: 'col-sm-6 col-md-6',
		autoComplete: 'off'
	},
	{
		key: PARTNER_FEES_FORM_FIELDS.MIN_FEE_AMOUNT,
		fieldName: PARTNER_FEES_FORM_FIELDS.MIN_FEE_AMOUNT,
		placeholder: PARTNER_FEES_FORM_FIELDS_NAMES.MIN_FEE_AMOUNT,
		label: PARTNER_FEES_FORM_FIELDS_NAMES.MIN_FEE_AMOUNT,
		inputType: InputType.Number,
		required: true,
		additionalClasses: 'col-sm-6 col-md-6',
		autoComplete: 'off'
	},
	// {
	// 	key: PARTNER_FEES_FORM_FIELDS.APPLIED_ON,
	// 	fieldName: PARTNER_FEES_FORM_FIELDS.APPLIED_ON,
	// 	placeholder: PARTNER_FEES_FORM_FIELDS_NAMES.APPLIED_ON,
	// 	label: PARTNER_FEES_FORM_FIELDS_NAMES.APPLIED_ON,
	// 	inputType: InputType.Text,
	// 	// required: true,
	// 	additionalClasses: 'col-sm-6 col-md-3'
	// },
];
